import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import styles from './styles/Forsale.module.css';

const ForSale = () => {
	return (
		<div className={styles.background}>
			<Container>
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<Row>
					<Col>
						<h1 className={styles.forSaleHeader}>
							<b>For Sale</b>
						</h1>
						<hr className={styles.divider} />
					</Col>
				</Row>
				<Row>
					<Col
						xs={12}
						sm={12}
						md={{ span: 6, offset: 3 }}
						lg={{ span: 6, offset: 3 }}
					>
						<br />
						<div className='card'>
							<br />
							<div className='card-title text-center'>
								<h3 style={{ padding: '20px', color: '#08458e' }}>
									There are no trailers, lots, docks or items posted for sale at
									this time.{' '}
								</h3>
							</div>

							{/* <div className='card-title'>
								<h3 class={styles.forSaleHeaderSmall}>JET SKI DOCK FOR RENT</h3>
							</div>
							<div className='card-body text-center'>
								<h5 className={styles.forSaleDesc}>
									Available to rent for the 2026 season <br />
									(Plymouth Shore members only)
								</h5>
								<p className={styles.forSaleDesc}>Jet Ski Dock #49</p>
								<p className={styles.forSaleDesc}>Rate: $400</p>
								<p className={styles.forSaleDesc}>
									Please contact Bruce Ryan for details
								</p>
								<p className={styles.forSaleDesc}>Ph: 440-655-3571</p>
								<p className={styles.blue}>[Posted on 3/26/26]</p>
							</div> */}
							<div className='card-body'></div>
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	);
};

export default ForSale;
